<template>
    <section class="agenda-select-overlay" @click.self="close">
        <section class="agenda-select-modal">
            <header class="agenda-select-modal__header">
                <h3 class="agenda-select-modal__title">{{ $t('com.file.room-map.agenda-points') }}</h3>
                <button class="agenda-select-modal__close" @click="close">
                    <img src="@/assets/icons/components/exit-btn.svg" alt="Close" />
                </button>
            </header>
            <section class="agenda-select-modal__body">
                <label class="agenda-select-modal__label" for="agenda-select">
                    {{$t('com.file.edit-point.about')}}
                </label>
                <select id="agenda-select"
                        v-model="selectedId"
                        class="agenda-select-modal__select">
                    <option disabled value="">{{ $t('com.file.drag-voting-to-point-modal.select-point')}}</option>
                    <option v-for="item in flatAgendaItems"
                            :key="item.id"
                            :value="item.id">
                        {{ item.label }}
                    </option>
                </select>
            </section>
            <footer class="agenda-select-modal__footer">
                <button class="agenda-select-modal__button" @click="close">
                    {{ $t('com.global.cancel') }}
                </button>
                <button class="agenda-select-modal__button agenda-select-modal__button--primary" :disabled="!selectedId || getInteractiveVotingModalInAppStatus === true" @click="confirm">
                    {{ $t('com.global.select') }}
                </button>
            </footer>
        </section>
    </section>
</template>

<script>
    export default {
        name: "SelectAgendaItemModal",
        props: {
            agendaItems: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                selectedId: ""
            }
        },
        computed: {
            flatAgendaItems() {
                const result = [];
                const walk = (items, level = 0) => {
                    if (!Array.isArray(items)) return;
                    items.forEach(item => {
                        if (!item || item.id == null) return;
                        const prefix = level > 0 ? '— '.repeat(level) : '';
                        const rawName = item.name || item.title || this.$t('com.global.no-name') || 'Bez nazwy';
                        const name = typeof rawName === 'string' ? rawName : String(rawName);
                        const truncated = name.length > 100 ? `${name.slice(0, 100)}…` : name;
                        result.push({
                            id: item.id,
                            label: `${prefix}${truncated}`
                        });
                        if (item.subItems && item.subItems.length) {
                            walk(item.subItems, level + 1);
                        }
                    });
                };
                walk(this.agendaItems, 0);
                return result;
            },
            getInteractiveVotingModalInAppStatus() {
                return this.$store.state.votingStore.interactiveVotingModalInAppStatus;
            }
        },
        methods: {
            close() {
                this.$emit('close');
                this.selectedId = "";
            },
            confirm() {
                if (!this.selectedId) return;
                this.$emit('confirm', this.selectedId);
                this.selectedId = "";
                this.close();
            }
        }
    }
</script>

<style scoped lang="scss">
    .agenda-select-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 8, 44, 0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 12000;
    }

    .agenda-select-modal {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 25px 80px rgba(0, 8, 44, 0.35);
        min-width: 420px;
        max-width: 520px;
        width: 90%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border: 1px solid #e5e8f0;
    }

    .agenda-select-modal__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 20px;
        border-bottom: 1px solid #e5e8f0;
    }

    .agenda-select-modal__title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f1c46;
    }

    .agenda-select-modal__close {
        background: transparent;
        border: none;
        padding: 6px;
        cursor: pointer;
    }

    .agenda-select-modal__body {
        padding: 18px 20px 6px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .agenda-select-modal__label {
        font-size: 14px;
        font-weight: 600;
        color: #1b2a52;
    }

    .agenda-select-modal__select {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #cfd6e4;
        border-radius: 8px;
        font-size: 14px;
        color: #0f1c46;
        background: #fff;
        outline: none;
    }

    .agenda-select-modal__select:focus {
        border-color: #004dcc;
        box-shadow: 0 0 0 2px rgba(0, 77, 204, 0.12);
    }

    .agenda-select-modal__footer {
        padding: 16px 20px 20px;
        display: flex;
        justify-content: space-between;
        gap: 10px;
    }

    .agenda-select-modal__button {
        padding: 14px 28px;
        min-width: 160px;
        height: 48px;
        border: 1px solid #bbc2ce;
        box-sizing: border-box;
        border-radius: 4px;
        background-color: transparent;
        font-weight: 600;
        font-size: 15px;
        line-height: 132%;
        color: #00082c;
        transition: all 0.2s ease-in-out;
        cursor: pointer;

        &:hover {
            background-color: #e8ebef;
        }
    }

    .agenda-select-modal__button--primary {
        background-color: #d80418; /* spójnie z btn-voting */
        border: none;
        color: #fff;

        &:hover {
            background-color: #ad0313;
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            background-color: #d80418;
        }
    }
</style>

